<template>
	<div class="gifts-box-wrap">
		<div class="page-header">
			<span class="back-btn" @click="closeBox"><img src="../../assets/img/chats/ic_nav_back_pressed@2x.png"/></span>
			<p class="page-title">礼物箱</p>
		</div>
		<div class="gift-list">
			<mt-loadmore :top-method="refreshList" :bottom-method="loadMoreList" :auto-fill="false" ref="loadmore">
			<ul>
				<li v-for="(item,index) in listInfo">
					<img :src="item.girft_img_url"/>
					<p class="item-name">{{item.girft_name}}</p>
					<p class="item-num">{{item.g_nums}}</p>
				</li>
			</ul>
			</mt-loadmore>
		</div>
	</div>
</template>

<script>
	export default{
		name:"his-gifts-box",
		props:["uid"],
		data(){
			return{
				listInfo:"",
				nowPage:1,
			}
		},
		created(){
			this.getList();
		},
		methods:{
			getList(){
				this.$axios({
					url:"My/GiftBox",
					method:"post",
					data:{
						uid:this.uid,
					}
				}).then(res=>{
					console.log(res);
					if(res.data.code==200){
						
						this.$toast({
							message:res.data.msg,
							position:"bottom",
							duration:3000
						})
						if(this.nowPage==1){
							this.listInfo = res.data.data;
						}else{
							if(res.data.data.length<1){
								
								this.nowPage--;
							}else{
								this.listInfo = this.listInfo.concat(res.data.data);
							}
						}
					}else{
						
						this.$toast({
							message:"没有更多内容了",
							position:"bottom",
							duration:3000
						})
					}
				}).catch(err=>{
					console.log(err)
				})
			},
			refreshList(){
				this.nowPage = 1;
				this.getList();
				this.$refs.loadmore.onTopLoaded();
			},
			loadMoreList(){
				this.nowPage++;
				
				this.getList();
				this.$refs.loadmore.onBottomLoaded();
			},
			closeBox(){
				this.$emit("closeBox")
			}
		}
	}
</script>

<style scoped>
.gifts-box-wrap{
	width: 100vw;
	height: 100vh;
	position: fixed;
	top: 0;
	left: 0;
	background: #fff;
	z-index: 10;
}
.page-header{
	width: 100%;
	height: 2.5rem;
	display: flex;
	justify-content: center;
	align-items: center;
	font-size: 0.95rem;
	color: #282828;
	position: relative;
	border-bottom: 1px solid #f3f3f3;
}
.page-header img{
	width: 2.5rem;
}
.page-header .back-btn{
	position: absolute;
	left: 0;
	top: 1px;
}
.gift-list{
	height: calc(100vh - 2.5rem);
	overflow-y: scroll;
}
.gift-list ul{
	display: flex;
	justify-content: flex-start;
	align-items: center;
	flex-wrap: wrap;
	padding: 1rem 0;
}
.gift-list li{
	width: 33%;
	text-align: center;
	padding: 0.5rem 0 0.2rem;
}
.gift-list li img{
	width: 3rem;
	display: inline-block;
}
.gift-list li .item-name{
	font-size: 0.9rem;
	color: #282828;
}
.gift-list li .item-num{
	font-size: 0.8rem;
	color: #7b7b7b;
}
</style>


// WEBPACK FOOTER //
// src/components/Mine/HisGiftsBox.vue